export default __webpack_public_path__ + "static/10-8a5ec43586099df3b439d8be0e797974.webp";